<pui-table2 [dataSource]="entityUsers" [trackBy]="trackBy" [sortBy]="sort().key" [sortDirection]="sort().direction"
  (sortChange)="onSortChange($event)" class="details-table">
  <ng-template #header>
    <th>Imię</th>
    <th>Nazwisko</th>
    <th>Komórka uprawniona</th>
    <th>Konto</th>
    <th>Akcje</th>
  </ng-template>
  <ng-template #row let-row>
    <tr>
      <td>{{ row.firstName }}</td>
      <td>{{ row.lastName}}</td>
      <td>{{ row.organization }}</td>
      <td>Brak <span (click)="onCreateAccount()">Utwórz konto</span></td>
      <td>
        <button pui-button variant="tertiary" (click)="onLinkAccount(row.uuid)"><pui-icon class="action-icon" left
            icon="user-plus-02" /></button>
        <button pui-button variant="tertiary" (click)="onEditUser(row.uuid)"><pui-icon class="action-icon" left
            icon="edit-03" /></button>
        <button pui-button variant="tertiary" (click)="onDeleteUser(row)"><pui-icon left icon="trash-03"
            class="remove-icon" /></button>
      </td>
    </tr>
  </ng-template>
  <pui-empty-state icon="file-x-02" title="Nie masz jeszcze żadnych osób uprawnionych">
  </pui-empty-state>
</pui-table2>